
export type InputFieldSizeType = number | null;
















export const enum InputFieldNames {
  CUSTOMER_ADDRESS = 'customer.address',
  CUSTOMER_CITY = 'customer.city',
  CUSTOMER_EMAIL = 'customer.email',
  CUSTOMER_FIRSTNAME = 'customer.first_name',
  CUSTOMER_LASTNAME = 'customer.last_name',
  CUSTOMER_MOBILE = 'customer.mobile',
  CUSTOMER_PHONE = 'customer.phone',
  CUSTOMER_ZIP = 'customer.zip',
  //
  ORDER_ARTICLE_NR = 'order.articlenr',
  ORDER_CUSTOMER_ID = 'order.customer_id',
  ORDER_PARTNER_ID = 'order.partner_id',
  ORDER_KM = 'order.km',
  ORDER_CAR_KIND = 'order.kind',
  ORDER_CAR_DESCRIPTION = 'order.car_description',
  ORDER_FIRST_REG = "order.first_reg",
  ORDER_DAMAGE = 'order.damage',
  ORDER_DAMAGE_DAY = "order.damage_day",
  ORDER_DAMAGE_LOCATION = 'order.damage_location',
  ORDER_DAMAGE_NR = 'order.damage_nr',
  ORDER_DEDUCTIBLE = "order.deductible",
  //ORDER_DEDUCTIBLE_CUSTOMER = "order.deductible_customer_status",
  ORDER_DEDUCTIBLE_CUSTOMER_PART = "order.deductible_customer_part",
  ORDER_HALTER = 'order.halter',
  ORDER_INSURANCE = 'order.insurance',
  ORDER_PLATE = 'order.plate',
  ORDER_MONTAGE_ADDRESS = 'order.montage_address',
  ORDER_MONTAGE_ZIP = 'order.montage_zip',
  ORDER_MONTAGE_CITY = 'order.montage_city',
  ORDER_WORK_DAY = "order.work_day",
  ORDER_WORK_TIMES = "order.work_times",
  //
  TEAM_EMAIL = 'team.email',
  TEAM_FIRSTNAME = 'team.first_name',
  TEAM_LASTNAME = 'team.last_name',
  TEAM_MOBILE = 'team.mobile',
  TEAM_USERNAME = 'team.username',
}

export const InputFieldSizes: any = {
  [InputFieldNames.CUSTOMER_ADDRESS]: 45,
  [InputFieldNames.CUSTOMER_CITY]: 45,
  [InputFieldNames.CUSTOMER_EMAIL]: 45,
  [InputFieldNames.CUSTOMER_FIRSTNAME]: 45,
  [InputFieldNames.CUSTOMER_LASTNAME]: 45,
  [InputFieldNames.CUSTOMER_MOBILE]: 45,
  [InputFieldNames.CUSTOMER_PHONE]: 45,
  [InputFieldNames.CUSTOMER_ZIP]: 10,
  /**/
  [InputFieldNames.ORDER_ARTICLE_NR]: 64,
  [InputFieldNames.ORDER_CAR_KIND]: 32,
  [InputFieldNames.ORDER_CAR_DESCRIPTION]: 256,
  [InputFieldNames.ORDER_DAMAGE]: 256,
  [InputFieldNames.ORDER_DAMAGE_LOCATION]: 256,
  [InputFieldNames.ORDER_DAMAGE_NR]: 64,
  [InputFieldNames.ORDER_HALTER]: 90,
  [InputFieldNames.ORDER_INSURANCE]: 64,
  [InputFieldNames.ORDER_PLATE]: 16,
  //
  [InputFieldNames.ORDER_MONTAGE_ADDRESS]: 45,
  [InputFieldNames.ORDER_MONTAGE_CITY]: 45,
  [InputFieldNames.ORDER_MONTAGE_ZIP]: 12,
  /**/
  [InputFieldNames.TEAM_EMAIL]: 45,
  [InputFieldNames.TEAM_FIRSTNAME]: 45,
  [InputFieldNames.TEAM_LASTNAME]: 45,
  [InputFieldNames.TEAM_MOBILE]: 45,
  [InputFieldNames.TEAM_USERNAME]: 45,
};
